module.exports = __webpack_public_path__ + "static/gem-low-rate-hero-4be9d68896c2fe867dd9ebed9febfb82.jpg";